import React, { useState, useEffect } from 'react';
import { useApi } from "../hooks/useApi";
import DownloadFileButton from "../hooks/DownloadFileButton";
function DBviewer() {
    // --- STATE MANAGEMENT ---
    const [tables, setTables] = useState([]); // List of string table names
    const [selectedTable, setSelectedTable] = useState(null);

    // Results view payload
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const [backupsuccess, setBackupsuccess] = useState(null);
    // SQL Query editor input string
    const [customQuery, setCustomQuery] = useState('');
    const { apiCall } = useApi();
    // --- AJAX/FETCH HANDLERS (PLACEHOLDERS) ---

    // 1. Initial Load: Fetch all database table names
    useEffect(() => {
        setIsLoading(true);
        // Replace with your real AJAX endpoint
        apiCall('dbtool-get_all_tables')
            .then((res) => res.json())
            .then((data) => {
                // Expected format: ['users', 'orders', 'products']
                setTables(data || []);
                setIsLoading(false);
            })
            .catch((err) => {
                setError('Failed to load database tables.');
                setIsLoading(false);
            });
    }, []);

    // 2. Fetch first 20 records for a specific table
    const fetchTablePreview = (tableName) => {
        setSelectedTable(tableName);
        setError(null);
        setIsLoading(true);

        // Auto-populate query input box for visibility convenience
        setCustomQuery(`SELECT * FROM ${tableName} LIMIT 20;`);

        // Replace with your real AJAX preview endpoint
        apiCall(`dbtool-get_table`, { params: { table: tableName } })
            .then((res) => res.json())
            .then((data) => {
                // Expected structure: { columns: ['id', 'name'], rows: [{id: 1, name: 'Alice'}] }
                setColumns(data.columns || []);
                setRows(data.rows || []);
                setIsLoading(false);
            })
            .catch((err) => {
                setError(`Failed to fetch preview for table: ${tableName}`);
                setIsLoading(false);
            });
    };

    // 3. Execute custom text area SQL Query box
    const handleExecuteQuery = (e) => {
        e.preventDefault();
        if (!customQuery.trim()) return;

        setSelectedTable(null); // Clear selected sidebar table highlighters
        setError(null);
        setMessage(null);
        setIsLoading(true);

        // Replace with your real AJAX custom-query processing endpoint
        apiCall(`dbtool-execute_custom_query`, { params: { query: btoa(customQuery) } })

            .then((res) => res.json())
            .then((data) => {
                if (data && data.error) {
                    throw data.error;
                }
                // Same expected structure: { columns: [...], rows: [...] }
                setColumns(data.columns || []);
                setRows(data.rows || []);
                setMessage(data.message || '');
                setIsLoading(false);


            })
            .catch((err) => {
                if (err) {
                    setError(err);
                }
                else {
                    setError('Error executing query syntax. Check your connection or SQL formatting.');
                }

                setIsLoading(false);
            });
    };

    // 3. Execute custom text area SQL Query box
    const backupDB = (e) => {
        e.preventDefault();

        setSelectedTable(null); // Clear selected sidebar table highlighters
        setMessage(null);
        setError(null);
        setIsLoading(true);

        // Replace with your real AJAX custom-query processing endpoint
        apiCall(`dbtool-backup_db`)
            .then((res) => res.json())
            .then((data) => {
                if (data && data.error) {
                    throw data.error;
                }

                setIsLoading(false);
                if (data && data.message) {
                    setMessage(data.message);
                    setBackupsuccess(true);
                }
            })
            .catch((err) => {
                if (err) {
                    setError(err);
                }
                else {
                    setError('Error executing query syntax. Check your connection or SQL formatting.');
                }

                setIsLoading(false);
            });
    };


    return (
        <div style={{ display: 'flex', fontFamily: 'sans-serif', height: '100vh', backgroundColor: '#fafafa' }}>

            {/* --- LEFT SIDEBAR: TABLES LIST --- */}
            <div style={{ width: '300px', borderRight: '1px solid #ddd', backgroundColor: '#fff', padding: '15px', overflowY: 'auto' }}>
                <h3 style={{ marginTop: 0, paddingBottom: '10px', borderBottom: '1px solid #eee' }}>🗄️ Tables</h3>
                {tables.length === 0 && !isLoading && <p style={{ color: '#888', fontSize: '14px' }}>No tables found.</p>}
                <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                    {tables.map((table) => (
                        <li key={table} style={{ marginBottom: '6px' }}>
                            <button
                                onClick={() => fetchTablePreview(table)}
                                style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    backgroundColor: selectedTable === table ? '#e0f2fe' : 'transparent',
                                    color: selectedTable === table ? '#0369a1' : '#333',
                                    fontWeight: selectedTable === table ? 'bold' : 'normal',
                                }}
                            >
                                📋 {table}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* --- RIGHT PANEL: EXECUTION BOX & VIEW DATA GRID --- */}
            <div style={{ flex: 1, padding: '20px', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>

                {/* Custom Query Entry Section */}
                <div style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '20px' }}>
                    <h4 style={{ margin: '0 0 10px 0' }}>Run Custom SQL Query</h4>
                    <form onSubmit={handleExecuteQuery}>
                        <textarea
                            value={customQuery}
                            onChange={(e) => setCustomQuery(e.target.value)}
                            placeholder="SELECT * FROM table_name WHERE condition LIMIT 20;"
                            rows={4}
                            className="p-3 rounded-sm w-full border-2 border-gray-100"

                        />
                        <div className="flex justify-between items-center mt-3">
                            <button
                                type="submit"
                                className="btn btn-primary"

                            >
                                ⚡ Run Query
                            </button>
                            <div>
                                <div className="mb-4">
                                    <button className='btn btn-primary'
                                        onClick={backupDB}
                                        disabled={isLoading}
                                    >
                                        Backup DB
                                    </button>

                                    {backupsuccess && (
                                        <DownloadFileButton
                                            route="dbtool-download_db_backup_file"
                                            filename="db_backup.sql.gz"
                                            buttonText="Export DB Backup (.gz)"
                                            apiCall={apiCall}
                                        />
                                    )}

                                </div>
                            </div>
                        </div>

                    </form>
                </div>

                {/* Messaging Feedback Badges */}


                {isLoading && <div style={{ color: '#2563eb', fontWeight: 'bold', padding: '10px 0' }}>🔄 Processing requested actions...</div>}
                {message && <div style={{ color: 'green', backgroundColor: '#fee2e2', padding: '12px', borderRadius: '4px', margin: '10px 0' }}>{message}</div>}

                {error && <div style={{ color: '#dc2626', backgroundColor: '#fee2e2', padding: '12px', borderRadius: '4px', margin: '10px 0' }}>⚠️ {error}</div>}

                {/* Dynamic Display Matrix Table Result */}
                <div style={{ flex: 1, backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '6px', padding: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <h4 style={{ margin: '0 0 10px 0' }}>
                        {selectedTable ? `Displaying First 20 Rows: ${selectedTable}` : 'Query Target Outflow Results'}
                    </h4>

                    <div style={{ flex: 1, overflowX: 'auto', overflowY: 'auto' }}>
                        {columns.length > 0 ? (
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', textAlign: 'left' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                                        {columns.map((col, idx) => (
                                            <th key={idx} style={{ padding: '10px', border: '1px solid #e5e7eb', color: '#374151' }}>{col}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, rIdx) => (
                                        <tr key={rIdx} style={{ borderBottom: '1px solid #e5e7eb', backgroundColor: rIdx % 2 === 0 ? '#fff' : '#f9fafb' }}>
                                            {columns.map((col, cIdx) => {
                                                const val = row[col];
                                                return (
                                                    <td key={cIdx} style={{ padding: '10px', border: '1px solid #e5e7eb', fontFamily: 'monospace' }}>
                                                        {val !== undefined && val !== null ? String(val) : <span style={{ color: '#b91c1c', fontStyle: 'italic' }}>NULL</span>}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            !isLoading && <p style={{ color: '#666', textAlign: 'center', marginTop: '40px' }}>Select a table on the left or run a query to inspect records.</p>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default DBviewer;
